import { Tab } from '@headlessui/react'
import React, { lazy, Suspense } from 'react'
import LoadingSpinner from 'shared/components/loading/loading-spinner'

const FollowUpRequests = lazy(() => import('./FollowUpRequests'))
const OtherPanel = lazy(() => import('./Other'))
const PriceInquiryTab = lazy(() => import('./PriceInquiry'))
const TransferToOtherUnits = lazy(() => import('./TransferToOtherUnits'))

const TABS = [
  PriceInquiryTab,
  FollowUpRequests,
  TransferToOtherUnits,
  OtherPanel,
]

function TabPanelsContainer() {
  return (
    <Tab.Panels>
      <Suspense
        fallback={
          <div className="w-full flex justify-center">
            <LoadingSpinner className={'w-[15px] mx-auto'} />
          </div>
        }
      >
        {TABS.map((Panel) => (
          <Tab.Panel>{<Panel />}</Tab.Panel>
        ))}
      </Suspense>
    </Tab.Panels>
  )
}

export default TabPanelsContainer
